/**
 * Frontend Javascript
 *
 * @package LifterLMS_Advanced_Videos/Scripts
 *
 * @since 1.0.0-beta.1
 * @version 1.0.0-beta.10
 */

/**
 * Method called automatically when the YouTube JS Player API is loaded.
 *
 * @since 1.0.0-beta.1
 *
 * @return {void}
 */
function onYouTubeIframeAPIReady() {

	jQuery( '.llms-av-embed iframe[src*="youtube.com"]' ).each( function() {

		new YT.Player( jQuery( this )[ 0 ], {
			events: {
				onReady: function( event ) {
					window.llms.av.player_ready( 'youtube', event.target );
				},
			},
		} );

	} );

}

( function( $ ) {

	/**
	 * LifterLMS Advanced Videos Class.
	 *
	 * @since 1.0.0-beta.1
	 * @since 1.0.0-beta.2 Fix syntax error when checking for async loading of the Vimeo player SDK.
	 *                     Introduce `get_custom_controls()` to retrieve the player custom controls jQuery element.
	 *                     Fix issue causing elapsed time (in hh:mm:ss) to be incorrectly reported on slim controls player.
	 *                     Add Wistia Support.
	 * @since 1.0.0-beta.3 Fix video end event for Wistia players.
	 * @since 1.0.0-beta.6 Toggle mark complete button only if the video completion is required.
	 * @since 1.0.0-beta.7 Toggle mark complete button(take quiz) on init only if the video completion is
	 *                     required and video not completed.
	 * @since 1.0.0-beta.10 Added logic to track player `paused` event just before the window unloads (reload/exit).
	 *                     Fixed issue that prevented the video to start from the right position with Wistia and Vimeo players.
	 *                     Fixed js error when seeking while a Vimeo video is already playing.
	 */
	var LLMS_Advanced_Videos = function() {

		var self     = this,
			settings = {};

		/**
		 * Initialize.
		 *
		 * @since 1.0.0-beta.1
		 * @since 1.0.0-beta.2 `'undefined'` not `undefined`.
		 *                     Add Wistia support.
		 *
		 * @return {void}
		 */
		this.init = function() {

			var tracking_settings = llms.tracking.getSettings();
			if ( tracking_settings.av ) {
				settings = tracking_settings.av;
			}

			// Maybe initialize Vimeo players.
			var $vimeos = $( '.llms-av-embed iframe[src*="vimeo.com"]' );
			if ( $vimeos.length ) {
				LLMS.wait_for( function() {
					return ( 'undefined' !== typeof Vimeo );
				}, function() {
					$vimeos.each( function() {
						self.player_ready( 'vimeo', new Vimeo.Player( $( this )[ 0 ] ) );
					} );
				} );
			}

			// Maybe initialize Wistia players.
			var $wistias = $( '.llms-av-embed iframe[src*="wistia.net"]' );
			if ( $wistias.length ) {
				LLMS.wait_for( function() {
					return ( 'undefined' !== typeof window._wq );
				}, function() {
					window._wq = window._wq || [];
					_wq.push( {
						id: '_all',
						onReady: function( player ) {
							self.player_ready( 'wistia', player );
						},
					} );
				} );
			}

		};

		/**
		 * Callback function when a video player is ready for a provider.
		 *
		 * @since 1.0.0-beta.1
		 * @since 1.0.0-beta.2 Add Wistia Support.
		 * @since 1.0.0-beta.6 Toggle mark complete button on init only if the video completion is required.
		 * @since 1.0.0-beta.7 Toggle mark complete button(take quiz) on init only if the video completion is
		 *                     required and video not completed
		 *
		 * @param {string} provider Provider ID, eg "youtube".
		 * @param {Object} player Player instance from the provider's player API/SDK.
		 * @return {void}
		 */
		this.player_ready = function( provider, player ) {

			var autoplay = ( '1' === new URLSearchParams( window.location.search ).get( 'autoplay' ) );

			if ( settings.require_video_completion && ! settings.video_completed ) {
				toggle_mark_complete( false );
			}

			if ( 'vimeo' === provider ) {
				vimeo_player_ready( player, autoplay );
			} else if ( 'wistia' === provider ) {
				wistia_player_ready( player, autoplay );
			} else if ( 'youtube' === provider ) {
				youtube_player_ready( player, autoplay );
			}

		};

		/**
		 * Record video completion via AJAX.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {Object} $el Wrapper element ('.llms-av-embed').
		 * @return {void}
		 */
		function do_ajax_completion( $el ) {

			LLMS.Ajax.call( {
				data: {
					action: 'llms_av_video_ended',
					id: settings.post_id,
					nonce: settings.nonce,
				},
				beforeSend: function() {
					LLMS.Spinner.start( $el );
				},
				error: function( xhr, status, error ) {

					LLMS.Spinner.stop( $el );
					console.error( xhr.responseText + ' (' + error + ' ' + status + ')' ); /* eslint-disable-line no-console */
					console.log( xhr ); /* eslint-disable-line no-console */

				},
				success: function( res ) {

					LLMS.Spinner.stop( $el );

					if ( res.html ) {
						$el.append( res.html );
						start_countdown( $el );
					}

				},

			} );

		}

		/**
		 * Retrieves the custom controls, if any.
		 *
		 * @since 1.0.0-beta.2
		 *
		 * @param {Object} $iframe Iframe object.
		 * @return {Object} Controls element or zero length object, if no custom controls.
		 */
		function get_custom_controls( $iframe ) {
			return $iframe.closest( '.llms-av-embed' ).find( '.llms-av-controls' );
		}

		/**
		 * Determines if the video player has custom controls.
		 *
		 * This will be true when the "control-less" UI is loaded.
		 *
		 * @since 1.0.0-beta.1
		 * @since 1.0.0-beta.2 Use `get_custom_controls()` to retrieve the custom controls jQuery element.
		 *
		 * @param {Object} $iframe Iframe object.
		 * @return {boolean} True if controls exist, false otherwise.
		 */
		function has_custom_controls( $iframe ) {
			return get_custom_controls( $iframe ).length ? true : false;
		}

		/**
		 * Player event for video playback completion.
		 *
		 * @since 1.0.0-beta.1
		 * @since 1.0.0-beta.6 Toggle mark complete button only if the video completion is required.
		 *
		 * @param {Object} $el Wrapper element, `.llms-av-embed`.
		 * @param {Object} meta {
		 *     Hash of meta information for the event.
		 *
		 *     @type {number} ts Duration of the video that's been played (in seconds).
		 *     @type {number} duration Total video duration (in seconds).
		 *     @type {string} url Video URL.
		 *     @type {string} provider Provider ID.
		 * }
		 * @return {void}
		 */
		function player_on_end( $el, meta ) {

			track_event( 'ended', meta );
			do_ajax_completion( $el );
			if ( settings.require_video_completion ) {
				toggle_mark_complete( true );
			}

		}

		/**
		 * Player event for video pause.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {Object} $el Wrapper element, `.llms-av-embed`.
		 * @param {Object} meta {
		 *     Hash of meta information for the event.
		 *
		 *     @type {number} ts Duration of the video that's been played (in seconds).
		 *     @type {number} duration Total video duration (in seconds).
		 *     @type {string} url Video URL.
		 *     @type {string} provider Provider ID.
		 * }
		 * @return {void}
		 */
		function player_on_pause( $el, meta ) {

			track_event( 'paused', meta );
			$el.addClass( 'state--paused' );
			$el.removeClass( 'state--playing' );

		}

		/**
		 * Player event for video play.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {Object} $el Wrapper element, `.llms-av-embed`.
		 * @param {Object} meta {
		 *     Hash of meta information for the event.
		 *
		 *     @type {number} ts Duration of the video that's been played (in seconds).
		 *     @type {number} duration Total video duration (in seconds).
		 *     @type {string} url Video URL.
		 *     @type {string} provider Provider ID.
		 * }
		 * @return {void}
		 */
		function player_on_play( $el, meta ) {

			var event_id = meta.ts < 1 ? 'started' : 'played';
			track_event( event_id, meta );

			$el.addClass( 'state--playing' );
			$el.removeClass( 'state--paused' );

		}

		/**
		 * Prevent "Mark Complete" form submission and take quiz/assignment button clicks.
		 *
		 * This is unbound when the video has been completed.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {Object} event JS event object.
		 * @return {void}
		 */
		function prevent_default( event ) {
			event.preventDefault();
		}

		/**
		 * Start a countdown time in the "Next" button within the Post Video UI.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {Object} $el Wrapper element ('.llms-av-embed').
		 * @return {void}
		 */
		function start_countdown( $el ) {

			var $seconds = $el.find( '.llms-av-pv--seconds' ),
				time;

			setInterval( function() {

				time = ( $seconds.text() * 1 ) - 1;
				if ( 1 === time ) {
					$seconds.closest( 'a' )[ 0 ].click();
				}

				if ( time >= 0 ) {
					$seconds.text( time );
				}

			}, 1000 );

		}

		/**
		 * Converts seconds to HH:MM:SS format.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {number} seconds Number of seconds.
		 * @return {string} HH:MM:SS string.
		 */
		function to_hhmmss( seconds ) {

			var hours = Math.floor( seconds / 3600 ),
				mins  = Math.floor( seconds / 60 ) % 60,
				secs  = Math.round( seconds % 60 );

			return [ hours, mins, secs ].
				map( function( val ) {
					return val < 10 ? '0' + val : val;
				} ).
				filter( function( val, i ) {
					return val !== '00' || i > 0;
				} ).
				join( ':' );

		}

		/**
		 * Toggles mark complete form submission.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {boolean} enabled If true, enables submission, otherwise disables it.
		 * @return {void}
		 */
		function toggle_mark_complete( enabled ) {

			var $form  = $( '.llms-complete-lesson-form' ),
				$btn   = $( '.llms-complete-lesson-form button[type="submit"]' ),
				$links = $( '#llms_start_quiz, #llms-start-assignment' );

			if ( true === enabled ) {
				$form.off( 'submit', prevent_default );
				$btn.removeAttr( 'disabled' );
				$links.removeClass( 'llms-av-disabled' ).off( 'click', prevent_default );
			} else {
				$form.on( 'submit', prevent_default );
				$btn.attr( 'disabled', 'disabled' );
				$links.addClass( 'llms-av-disabled' ).on( 'click', prevent_default );
			}

		}

		/**
		 * Add a new event via llms.tracking
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {string} event_id Video event id, eg: 'started' or 'paused'.
		 * @param {Object} meta {
		 *     Hash of meta information for the event.
		 *
		 *     @type {number} ts Duration of the video that's been played (in seconds).
		 *     @type {number} duration Total video duration (in seconds).
		 *     @type {string} url Video URL.
		 *     @type {string} provider Provider ID.
		 * }
		 * @return {void}
		 */
		function track_event( event_id, meta ) {

			llms.tracking.addEvent( 'video.' + event_id, {
				meta: meta,
			} );

		}

		/**
		 * Update the progress of the "control-less" UI.
		 *
		 * @since 1.0.0-beta.1
		 * @since 1.0.0-beta.2 Use `get_custom_controls()` to retrieve the custom controls jQuery element.
		 *                     Fix issue causing elapsed time (in hh:mm:ss) to be incorrectly reported.
		 *
		 * @param {Object} $iframe Iframe object.
		 * @param {number} total Total video duration (in seconds).
		 * @param {number} elapsed Total elapsed time (in seconds).
		 * @param {number} buffered Total time that's been buffered (in seconds).
		 * @return {void}
		 */
		function update_progress( $iframe, total, elapsed, buffered ) {

			var $controls = get_custom_controls( $iframe );

			if ( false !== elapsed ) {
				var elapsed_perc = 0 === elapsed ? 0 : ( elapsed / total ) * 100;
				$controls.find( '.llms-av--progress .llms-av--elapsed' ).css( 'width', 'calc( ' + elapsed_perc + '% - 2px' );
			}

			if ( false !== buffered ) {
				buffered = 0 === buffered ? 0 : ( buffered / total ) * 100;
				$controls.find( '.llms-av--progress .llms-av--buffered' ).css( 'width', 'calc( ' + buffered + '% - 2px' );
			}

			if ( false !== total ) {

				var $time = $controls.find( '.llms-av--progress .llms-av--time' ),
					time  = to_hhmmss( elapsed );

				$time.text( time );
				if ( '00:00' !== time ) {
					$time.show();
				}

			}

		}

		/**
		 * Callback function when a Vimeo player is ready.
		 *
		 * Binds all events and manages the interface.
		 *
		 * @since 1.0.0-beta.1
		 * @since 1.0.0-beta.2 Use `get_custom_controls()` to retrieve the custom controls jQuery element.
		 * @since 1.0.0-beta.10 Added logic to track player `paused` event just before the window unloads (reload/exit).
		 *                     Fixed issue that prevented the video to start from the right position.
		 *                     Fixed js error when seeking while the video is already playing.
		 *
		 * @param {Object} player Vimeo player instance.
		 * @param {boolean} autoplay If autoplay is enabled for the video.
		 * @return {void}
		 */
		function vimeo_player_ready( player, autoplay ) {

			var $iframe      = $( player.element ),
				$wrapper     = $iframe.closest( '.llms-av-embed' ),
				player_state = {
					id: 0,
					// Is the player playing.
					is_playing: false,
					// Has the play button been clicked at least one time this page load.
					has_started: false,
					duration: 0,
					progress: '',
					paused_by_blur: false,
				};

			$wrapper.addClass( 'provider--vimeo' );

			// Start playing if autoplay is on.
			if ( true === autoplay ) {
				player.play();
			}

			// Controls are disabled, must update the UI on our custom controls.
			if ( has_custom_controls( $iframe ) ) {
				vimeo_update_progress( $iframe, player );
				setInterval( function() {
					vimeo_update_progress( $iframe, player );
				}, 150 );
				get_custom_controls( $iframe ).find( '.llms-av--play' ).on( 'click', function( event ) {
					event.preventDefault();
					player.getPaused().then( function( paused ) {
						if ( true === paused ) {
							player.play();
						} else {
							player.pause();
						}
					} );
				} );

				// Update buffer independently.
				player.on( 'progress', function( progress ) {
					update_progress( $iframe, progress.duration, false, progress.seconds );
				} );
			}

			player.on( 'play', function( data ) {
				/**
				 * This event is fired even when seeking on the progress bar while the player is playing.
				 * In that case no data is passed.
				 *
				 * @see https://github.com/gocodebox/lifterlms-advanced-videos/issues/24
				 */
				if ( ! data ) {
					return;
				}
				// Resume from saved timestamp if this is the first play and a timestamp is saved.
				if ( ! player_state.has_started && settings.last_user_timestamp <= data.duration - 5 ) {
					player.setCurrentTime( settings.last_user_timestamp );
					/**
					 * Set the data.seconds (to be stored as event meta) with the correct timestamp.
					 *
					 * @see https://github.com/gocodebox/lifterlms-advanced-videos/issues/30 2)
					 */
					data.seconds = settings.last_user_timestamp;
				}
				player_state.has_started = true;

				player.getVideoId().then( function( id ) {

					// Setup the player_state.
					$.extend(
						player_state,
						data,
						{
							id: id,
							is_playing: true,
						}
					);

					player_on_play( $wrapper, {
						ts: data.seconds,
						duration: data.duration,
						url: 'https://vimeo.com/' + id,
						provider: 'vimeo',
					} );
				} );

			} );

			player.on( 'pause', function( data ) {

				player_state.is_playing = false;

				player.getVideoId().then( function( id ) {
					player_on_pause( $wrapper, {
						ts: data.seconds,
						duration: data.duration,
						url: 'https://vimeo.com/' + id,
						provider: 'vimeo',
					} );
				} );
			} );

			player.on( 'ended', function( data ) {

				player_state.is_playing = false;

				player.getVideoId().then( function( id ) {
					player_on_end( $wrapper, {
						ts: data.seconds,
						duration: data.duration,
						url: 'https://vimeo.com/' + id,
						provider: 'vimeo',
					} );
				} );
			} );

			/**
			 * Cache the player progress
			 *
			 * @since 1.0.0-beta.10
			 *
			 * @return void
			 */
			player.on( 'progress', function() {
				/**
				 * The 'progress' event seems to be fired every 5-6s while the player plays.
				 *
				 * If we decide that we need much more precision, we should use the 'timeupdate'
				 * event which fires "generally every 250 ms during playback, but the interval can vary depending on the browser.",
				 * according to the api doc: https://developer.vimeo.com/player/sdk/reference#timeupdate
				 */
				player.getCurrentTime().then( function( ts ) {
					player_state.progress = ts;
				} );
			} );

			if ( settings.pause_on_blur ) {

				document.addEventListener( 'visibilitychange', function() {

					if ( document.hidden && settings.pause_on_blur ) {

						player.getPaused().then( function( paused ) {
							if ( false === paused ) {
								player_state.paused_by_blur = true;
								player.pause();
							}
						} );

					} else if ( ! document.hidden && settings.resume_on_focus && player_state.paused_by_blur ) {
						player.play();
						player_state.paused_by_blur = false;
					}

				} );

			}

			/**
			 * Before unloading the window (reload/exit)
			 *
			 * @since 1.0.0-beta.10
			 *
			 * @return void
			 */
			window.addEventListener( 'beforeunload', function() {
				/**
				 * When the window is closed the player will be paused
				 * but not 'paused' event will be catched, so here we
				 * track the `pause` event anyways, with the latest available
				 * information about the player state.
				 *
				 * For some reason, using the vimeo api in this callback
				 * was not reliable, the information - retrieved via promises -
				 * always came too late, after the window was reloaded.
				 *
				 * We don't actually pause the player here so there will always be
				 * a small difference in seconds (<10s) between the latest actual
				 * progress timestamp and the one we save.
				 * This is also due to the fact that we save the latest cached
				 * progress timestamp when the player's `progress` event is fired,
				 * which seems to happen each 5-6s.
				 */
				if ( player_state.is_playing ) {
					track_event( 'paused', {
						ts: player_state.progress,
						duration: player_state.duration,
						url: 'https://vimeo.com/' + player_state.id,
						provider: 'vimeo',
					} );
				}
			} );

		}

		/**
		 * Update "Control-less" interface for a Vimeo player.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {Object} $iframe Iframe object.
		 * @param {Object} player Vimeo Player instance.
		 * @return {void}
		 */
		function vimeo_update_progress( $iframe, player ) {

			Promise.all( [ player.getDuration(), player.getCurrentTime() ] ).then( function( values ) {
				update_progress( $iframe, values[ 0 ], values[ 1 ], false );
			} );

		}

		/**
		 * Callback function when a Wistia player is ready.
		 *
		 * Binds all events and manages the interface.
		 *
		 * @since 1.0.0-beta.2
		 * @since 1.0.0-beta.3 Fix video end event.
		 * @since 1.0.0-beta.10 Added logic to track player `paused` event just before the window unloads (reload/exit).
		 *                     Fixed issue that prevented the video to start from the right position.
		 *
		 * @param {Object} player Wistia player instance.
		 * @param {boolean} autoplay If autoplay is enabled for the video.
		 * @return {void}
		 */
		function wistia_player_ready( player, autoplay ) {

			var $iframe      = $( player.iframe ),
				$wrapper     = $iframe.closest( '.llms-av-embed' ),
				player_state = {
					// Has the play button been clicked at least one time this page load.
					has_started: false,
					paused_by_blur: false,
				};

			$wrapper.addClass( 'provider--wistia' );

			// Start playing if autoplay is on.
			if ( true === autoplay ) {
				player.play();
			}

			// Controls are disabled, must update the UI on our custom controls.
			if ( has_custom_controls( $iframe ) ) {
				wistia_update_progress( $iframe, player );
				setInterval( function() {
					wistia_update_progress( $iframe, player );
				}, 150 );
				get_custom_controls( $iframe ).find( '.llms-av--play' ).on( 'click', function( event ) {
					event.preventDefault();
					if ( 'playing' === player.state() ) {
						player.pause();
					} else {
						player.play();
					}

				} );
			}

			player.bind( 'play', function() {

				var duration = player.duration(),
					time     = player.time();

				// resume from saved timestamp if this is the first play and a timestamp is saved.
				if ( ! player_state.has_started && settings.last_user_timestamp <= duration - 5 ) {
					player.time( settings.last_user_timestamp );
					/**
					 * Make sure we log the correct timestamp.
					 *
					 * Looks like that getting the player time through `player.time()` right after
					 * having set it through `player.time(seconds)` doesn't return `seconds` as one
					 * might expect, but `0` - the starting time.
					 *
					 * @see https://github.com/gocodebox/lifterlms-advanced-videos/issues/30 2)
					 */
					time = settings.last_user_timestamp;
				}

				player_state.has_started = true;

				player_on_play( $wrapper, {
					ts: time,
					duration: duration,
					id: player.hashedId(),
					provider: 'wistia',
				} );

			} );

			player.bind( 'pause', function() {
				player_on_pause( $wrapper, {
					ts: player.time(),
					duration: player.duration(),
					id: player.hashedId(),
					provider: 'wistia',
				} );

			} );

			player.bind( 'end', function() {
				player_on_end( $wrapper, {
					ts: player.time(),
					duration: player.duration(),
					id: player.hashedId(),
					provider: 'wistia',
				} );
			} );

			if ( settings.pause_on_blur ) {

				document.addEventListener( 'visibilitychange', function() {

					if ( document.hidden && settings.pause_on_blur ) {

						if ( 'playing' === player.state() ) {
							player_state.paused_by_blur = true;
							player.pause();
						}

					} else if ( ! document.hidden && settings.resume_on_focus && player_state.paused_by_blur ) {
						player.play();
						player_state.paused_by_blur = false;
					}

				} );

			}

			/**
			 * Before unloading the window (reload/exit)
			 *
			 * @since 1.0.0-beta.10
			 *
			 * @return void
			 */
			window.addEventListener( 'beforeunloaad', function() {
				/**
				 * When the window is closed the player will be paused
				 * but not 'paused' event will be catched, so here we
				 * track the pause event anyways.
				 */
				if ( 'playing' === player.state() ) {
					track_event( 'paused', {
						ts: player.time(),
						duration: player.duration(),
						id: player.hashedId(),
						provider: 'wistia',
					} );
				}
			} );

		}

		/**
		 * Update "Control-less" interface for a Vimeo player.
		 *
		 * @since 1.0.0-beta.2
		 *
		 * @param {Object} $iframe Iframe object.
		 * @param {Object} player Vimeo Player instance.
		 * @return {void}
		 */
		function wistia_update_progress( $iframe, player ) {

			update_progress( $iframe, player.duration(), player.time(), false );

		}

		/**
		 * Callback function when a YouTube player is ready.
		 *
		 * Binds all events and manages the interface.
		 *
		 * @since 1.0.0-beta.1
		 * @since 1.0.0-beta.10 Added logic to track player `paused` event just before the window unloads (reload/exit).
		 *                     When resuming a video, avoid tracking a `started` event at 0s.
		 *
		 * @param {Object} player YouTube player instance.
		 * @param {boolean} autoplay If autoplay is enabled for the video.
		 * @return {void}
		 */
		function youtube_player_ready( player, autoplay ) {

			var $iframe      = $( player.getIframe() ),
				$wrapper     = $iframe.closest( '.llms-av-embed' ),
				player_state = {
					// Has the play button been clicked at least one time this page load.
					has_started: false,
					paused_by_blur: false,
				};

			$wrapper.addClass( 'provider--youtube' );

			// Start playing if autoplay is on.
			if ( true === autoplay ) {
				player.playVideo();
			}

			// Controls are disabled, must update the UI on our custom controls.
			if ( has_custom_controls( $iframe ) ) {
				youtube_update_progress( $iframe, player );
				setInterval( function() {
					youtube_update_progress( $iframe, player );
				}, 150 );
				get_custom_controls( $iframe ).find( '.llms-av--play' ).on( 'click', function( event ) {
					event.preventDefault();
					var state = player.getPlayerState();
					if ( 1 === state ) { // playing.
						player.pauseVideo();
					} else { // any other state.
						player.playVideo();
					}
				} );
			}

			player.addEventListener( 'onStateChange', function( event ) {

				var time     = Math.round( player.getCurrentTime() ),
					url      = player.getVideoUrl(),
					duration = player.getDuration();

				if ( 0 === event.data ) { // ended.

					player_on_end( $wrapper, {
						ts: time,
						duration: duration,
						url: url,
						provider: 'youtube',
					} );

				} else if ( 1 === event.data ) { // started.

					// Resume from saved timestamp if this is the first play and a timestamp is saved.
					if ( ! player_state.has_started && settings.last_user_timestamp <= duration - 5 ) {
						/**
						 * `seekTo()` fires another `onStateChange` with 1 === event.data
						 * So let's mark the player started - to avoid to enter this if block again -
						 * and bail.
						 */
						player.seekTo( settings.last_user_timestamp );
						player_state.has_started = true;
						return;
					}

					player_on_play( $wrapper, {
						ts: time,
						duration: duration,
						url: url,
						provider: 'youtube',
					} );

					player_state.has_started = true;

				} else if ( 2 === event.data ) { // paused.

					player_on_pause( $wrapper, {
						ts: time,
						duration: duration,
						url: url,
						provider: 'youtube',
					} );

				}

			} );

			if ( settings.pause_on_blur ) {

				document.addEventListener( 'visibilitychange', function() {

					if ( document.hidden && 2 !== player.getPlayerState() && settings.pause_on_blur ) {
						player_state.paused_by_blur = true;
						player.pauseVideo();
					} else if ( ! document.hidden && settings.resume_on_focus && player_state.paused_by_blur ) {
						player_state.paused_by_blur = false;
						player.playVideo();
					}

				} );

			}

			/**
			 * Before unloading the window (reload/exit)
			 *
			 * @since 1.0.0-beta.10
			 *
			 * @return void
			 */
			window.addEventListener( 'beforeunload', function() {
				/**
				 * When the window is closed the player will be paused
				 * but not 'paused' event will be catched, so here we
				 * track the pause event anyways.
				 */
				if ( 2 !== player.getPlayerState() ) {
					track_event( 'paused', {
						ts: Math.round( player.getCurrentTime() ),
						duration: player.getDuration(),
						url: player.getVideoUrl(),
						provider: 'youtube',
					} );
				}
			} );

		}

		/**
		 * Update "Control-less" interface for a YouTube player.
		 *
		 * @since 1.0.0-beta.1
		 *
		 * @param {Object} $iframe Iframe object.
		 * @param {Object} player YouTube Player instance.
		 * @return {void}
		 */
		function youtube_update_progress( $iframe, player ) {

			var total    = player.getDuration(),
				buffered = player.getVideoLoadedFraction() * total;
			update_progress( $iframe, total, player.getCurrentTime(), buffered );

		}

		// Go.
		this.init();

	};

	// Initialize on the global llms object.
	window.llms.av = new LLMS_Advanced_Videos();

}( jQuery ) );
